module.exports = __webpack_public_path__ + "static/media/b2-课植园.a8692c7d.png";